export default {
  state: {
    bankList: null,
    currentBank: {
      id: null,
      name: 'Loading...',
      phone_number: '',
      authorized: true,
      customers: []
    },
    currentBankUsers: []
  },
  getters: {
    bankList: state => state.bankList,
    currentBank: state => state.currentBank,
    currentBankId: state => {
      return (state.currentBank && state.currentBank.id) ? state.currentBank.id : ''
    },
    currentBankName: state => {
      return (state.currentBank) ? state.currentBank.name : 'Loading...'
    },
    currentBankPhone: state => {
      return (state.currentBank && state.currentBank.phone_number) ? state.currentBank.phone_number : ''
    },
    currentBankCustomers: state => {
      return (state.currentBank && state.currentBank.hasOwnProperty('customers') && Array.isArray(state.currentBank.customers)) ? state.currentBank.customers : []
    },
    currentBankUsers: state => state.currentBankUsers
  },
  mutations: {
    bankList (state, bankList: Array<Bank>) {
      state.bankList = bankList
    },
    resetCurrentBank (state) {
      state.currentBank = {
        id: null,
        name: 'Loading...',
        phone_number: '',
        authorized: true,
        customers: []
      }  
    },
    currentBank (state, bank: Bank) {
      console.log('commit currentBank', bank)
      if (bank) {
        state.currentBank = bank
      }
    },
    clearCurrentBank (state) {
      state.currentBank = {
        id: null,
        name: 'Loading...',
        customers: []
      }
    },
    currentBankUsers (state, users: Array<User>) {
      if (users) {
        state.currentBankUsers = users
      } else {
        state.currentBankUsers = []
      }
    }
  },
  actions: {

    async postNewBank ({getters}, bank: Bank) {
      console.log('store.postNewBank', bank)
      const api = getters.api
      const response = await api.post('banks', bank)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not add new bank."
        }
      }
      return response.data
    },

    async getBankList ({commit, getters}) {
      console.log('store.getBankList')
      const api = getters.api
      const response = await api.get('banks')
      if (response.status >= 300) {
        commit('bankList', [])
        return {
          success: false,
          message: "Could not get banks list."
        }
      }
      commit('bankList', (response.data.success ? response.data.data : []))
      return response.data
    },

    async getBank ({getters}, bankId: number) {
      console.log('store.getBank', bankId)
      const api = getters.api
      let response: any
      if (getters.sessionUserIsAdmin) {
        response = await api.get('banks/'+bankId)
      } else {
        response = await api.get('bank')
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get bank details."
        }
      }
      return response.data
    },

    async loadBank ({commit, getters, dispatch}, bankId: number) {
      if (!bankId) bankId = this.$route.params.bankId
      console.log('store.loadBank', bankId)
      const currentBankId = getters.currentBankId
      if (!bankId && currentBankId) bankId = currentBankId
      if (!bankId) {
        return {
          success: false,
          message: 'Missing bank ID.'
        }
      }
      commit('resetCurrentBank')
      const result = await dispatch('getBank', bankId)
      if (result.success) {
        commit('currentBank', result.data)
        commit('currentBankUsers', result.data.users)
        // await dispatch('loadBankUsers', bankId)
      }
      return result
    },

    async patchBank ({commit, getters}, bank: Bank) {
      console.log('store.patchBank', bank)
      const api = getters.api
      const response = await api.patch('banks/'+bank.id, bank)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not update bank details."
        }
      }
      return response.data
    },

    async addOrUpdateBank ({commit, getters, dispatch}, bank: Bank) {
      if (!bank) {
        return {
          success: false,
          message: 'No data'
        }
      }
      if (bank.id) {
        return await dispatch('patchBank', bank)
      } else {
        return await dispatch('postNewBank', bank)
      }
    },

    async loadBankUsers ({commit, getters, dispatch}, bankId: number) {
      console.log('store.loadBankUsers', bankId)
      const currentBankId = getters.currentBankId
      if (!bankId && currentBankId) bankId = currentBankId
      if (!bankId) {
        return {
          success: false,
          message: 'Missing bank ID.'
        }
      }
      const result = await dispatch('getBankUsers', bankId)
      commit('currentBankUsers', (result.success ? result.data : []))
      return result
    },

    async deleteBank ({commit, getters}, bank: Bank) {
      console.log('store.deleteBank', bank)
      const api = getters.api
      let response: any
      response = await api.delete('banks/'+bank.id)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not deauthorize bank."
        }
      }
      return response.data
    },

    // Customers //

    // async postNewCustomer ({getters}, cust: Customer) {
    //   console.log('store.postNewCustomer', cust)
    //   const api = getters.api
    //   let response: any
    //   if (getters.sessionUserIsBank) {
    //     response = await api.post(`customers`, cust)
    //   } else {
    //     response = await api.post(`banks/${cust.bank_id}/customers`, cust)
    //   }
    //   console.log('  response', response)
    //   if (response.status >= 300) {
    //     return {
    //       success: false,
    //       message: "Could not add new customer."
    //     }
    //   }
    //   return response.data
    // },
  
    async getCustomers ({state, getters}, bankId?: number) {
      console.log('store.getCustomers', bankId)
      if (!bankId && state.currentBank && state.currentBank.id) bankId = state.currentBank.id
      const api = getters.api
      let response: any
      if (getters.sessionUserIsBank) {
        response = await api.get('customers')
      } else if (bankId) {
        response = await api.get(`bank/${bankId}/customers`)
      } else {
        return {
          success: false,
          message: "Missing Bank ID."
        }
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get customers list."
        }
      }
      return response.data
    },

    // Debug

    logState ({state}) {
      console.log('store.banks', state)
    }

  }
}
